import * as React from 'react';
import { SVGProps } from 'react';

const SelectDropdownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.5}
      d="M11.97 16.506a1.487 1.487 0 0 1-1.06-.435l-5.971-6a1.506 1.506 0 0 1-.325-1.641 1.507 1.507 0 0 1 .811-.815 1.493 1.493 0 0 1 1.634.326l4.912 4.965 4.926-4.77a1.493 1.493 0 0 1 1.685-.381 1.493 1.493 0 0 1 .826.866 1.508 1.508 0 0 1-.45 1.675l-5.972 5.79a1.489 1.489 0 0 1-1.015.42Z"
      fill="#7F87B6"
    />
  </svg>
);

export default SelectDropdownIcon;
